export const INFINITE = 999999999999999;
export const TOKEN_EXPIRATION = 3600;